export default function modal() {
  $('a[data-modal]').on('click', function() {
    $($(this).data('modal')).modal({
      fadeDuration: 300,
      fadeDelay: 0,
    });
    return false;
  });
}
